import { render, staticRenderFns } from "./IdentificationType.vue?vue&type=template&id=2670b7e4&scoped=true&"
import script from "./IdentificationType.vue?vue&type=script&lang=js&"
export * from "./IdentificationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670b7e4",
  null
  
)

export default component.exports